// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".erp-tml-common-text-tooltip-wrap[data-v-b514add4] {\n  width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
